import { createBrowserRouter } from 'react-router';
import { BillingPage } from '@/pages/billing/billing';
import { ConnectionsPage } from '@/pages/connections/connections';
import { GetStartedPage } from '@/pages/get-started/get-started';
import { AppLayout } from '@/pages/layouts/app-layout';
import { CheckoutRoute } from '@/pages/layouts/checkout-route';
import { RouteErrorPage } from '@/pages/layouts/route-error';
import {
  GuestRoute,
  NewAccountRoute,
  SignedInRoute,
  WorkspaceRoute,
} from '@/pages/layouts/route-guards';
import { NotFoundPage } from '@/pages/not-found/not-found';
import { OverviewPage } from '@/pages/overview/overview';
import { SignInPage } from '@/pages/sign-in/sign-in';
import { SignInLinkPage } from '@/pages/sign-in-link/sign-in-link';
import { WelcomePage } from '@/pages/welcome/welcome';
import { ROUTES } from '@/shared/config/routes';

export function createRouter(): ReturnType<typeof createBrowserRouter> {
  return createBrowserRouter([
    {
      ErrorBoundary: RouteErrorPage,
      children: [
        { Component: GuestRoute, children: [{ path: ROUTES.SIGN_IN, Component: SignInPage }] },
        { path: ROUTES.SIGN_IN_LINK, Component: SignInLinkPage },
        {
          Component: SignedInRoute,
          children: [
            {
              Component: NewAccountRoute,
              children: [{ path: ROUTES.WELCOME, Component: WelcomePage }],
            },
            {
              Component: WorkspaceRoute,
              children: [
                {
                  Component: AppLayout,
                  children: [
                    { path: ROUTES.OVERVIEW, Component: OverviewPage },
                    { path: ROUTES.GET_STARTED, Component: GetStartedPage },
                    { path: ROUTES.BILLING, Component: BillingPage },
                    { path: ROUTES.CONNECTIONS, Component: ConnectionsPage },
                  ],
                },
                {
                  Component: CheckoutRoute,
                  children: [
                    {
                      path: ROUTES.PLANS,
                      lazy: () =>
                        import('@/pages/plans/plans').then((module) => ({
                          Component: module.PlansPage,
                        })),
                    },
                  ],
                },
              ],
            },
          ],
        },
        { path: '*', Component: NotFoundPage },
      ],
    },
  ]);
}
